import type { UserResponse } from "~types/user";
import type { UserTransformed } from "../types";
import transformPermission from "./transformPermission";

const transformUserDetailsResponse = (response: UserResponse): UserTransformed => {
  const user = response.data[0];

  if (!user) {
    console.error("User details response is empty");
    return {} as UserTransformed;
  }

  const resources = response?.includes?.resources || {};

  return {
    ...user,
    permissions: [
      ...user.userBasedPermissions.map((permission) => transformPermission(permission, resources, false)),
      ...user.roleBasedPermissions.map((permission) => transformPermission(permission, resources, true)),
    ],
  };
};

export default transformUserDetailsResponse;
